import { UserVO } from 'modules/user'
import { INTENTION_NAMES } from 'src/utils/constants'

export const INTENTION_NAMES_ALLOWED_PRODUCT_FRUIT = [
  INTENTION_NAMES.BEGINNER_PRODUCER,
  INTENTION_NAMES.BEGINNER_PRODUCER_LOW_POTENTIAL,
  INTENTION_NAMES.BEGINNER_PRODUCER_MEDIUM_POTENTIAL,
  INTENTION_NAMES.BEGINNER_PRODUCER_HIGH_POTENTIAL,
  INTENTION_NAMES.SEED_PRODUCER,
  INTENTION_NAMES.SMALL_PRODUCER,
  INTENTION_NAMES.MEDIUM_LARGE_PRODUCER,
  INTENTION_NAMES.NO_SALES_PRODUCER,
  INTENTION_NAMES.NO_SALES_PRODUCER_LOW_POTENTIAL,
  INTENTION_NAMES.NO_SALES_PRODUCER_MEDIUM_POTENTIAL,
  INTENTION_NAMES.INFLUENCER_PRODUCER,
  INTENTION_NAMES.SMALL_PRODUCER
]

const showProductFruitsOnAudiencePage = (user: UserVO) => {
  const {
    profile: { extensions, extensionsFreemium }
  } = user

  return extensions || extensionsFreemium
}

const productFruitsValidations = [showProductFruitsOnAudiencePage]

export const isExtensionSubscription = (user: UserVO): boolean => {
  const validationsResults = productFruitsValidations.map(productFruitsValidation => productFruitsValidation(user))
  const hasToRender = validationsResults.some(validationsResult => validationsResult)

  return hasToRender
}

export const isSigupLessThanThirtyDays = (signupTimestamp: number): boolean => {
  const THIRTY_DAYS = 30
  const currentTimestamp = new Date().getTime()
  const differenceInMilliseconds = currentTimestamp - signupTimestamp
  const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24)

  return differenceInDays < THIRTY_DAYS
}

export const isSalesProfileUserType = (userTypeInfo): boolean => {
  const salesProfileUserType = userTypeInfo?.salesProfileUserType
  const isSalesProfileUserType: boolean = ['producer', 'coproducer', 'hybrid'].includes(
    salesProfileUserType?.toLowerCase()
  )

  return isSalesProfileUserType
}
